module.exports = __webpack_public_path__ + "static/media/shootstalogo-with-subtitle.591c8332.svg";